import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class modView_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return `
            <div class="w-form w-form-large">
               <div class="form-header">
                    <input id="mod-id" data-bind="value: id" type="hidden">
                    <button class="btn icon i-back" type="button" data-bind="event: { click: onClickCancel }">Go Back</button>
                    <button class="btn icon i-edit" type="button" data-bind="event: { click: onClickEdit }">Edit Mod</button>
                </div>

                    <div>
                        <div class="w-form-body">
                            <div class="form-body">
                                <strong class="form-sub-title">Information</strong>
                                <div class="form-group">

                                    <dl class="double-list margin">
                                        <dt class=""><span>Title</span></dt>
                                        <dd class=""><span data-bind="text: title"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Short description</span></dt>
                                        <dd class="" style="white-space: pre-wrap;"><span data-bind="text: shortDescription"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Modder</span></dt>
                                        <dd class=""><a data-bind="attr: { href: '/website-users/edit/' + valnetUser() }"><span data-bind="text: modder"></a></span><span data-bind="visible: isModProbation" class="modder-probation">(<a data-bind="attr: { href: '/website-users/edit/' + valnetUser() }">in Probation</a>)</span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Status</span></dt>
                                        <dd class=""><span data-bind="text: status"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>ID Origin</span></dt>
                                        <dd class=""><span data-bind="text: idOrigin"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Tag</span></dt>
                                        <dd class=""><span data-bind="text: tag"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Is Adult Only</span></dt>
                                        <dd class=""><span data-bind="text: isAdultOnly"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>GGP Opt In</span></dt>
                                        <dd class=""><span data-bind="text: ggpOptIn"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Mod Types</span></dt>
                                        <div data-bind="foreach: modTypes" class="mod-types">
                                            <dd class=""><span data-bind="text: name"></span><span data-bind="visible: $index() < $parent.modTypes().length - 1">, </span></dd>
                                        </div>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Date Created</span></dt>
                                        <dd class=""><span data-bind="text: created"></span></dd>
                                    </dl>

                                    <dl class="double-list margin">
                                        <dt class=""><span>Date Updated</span></dt>
                                        <dd class=""><span data-bind="text: updated"></span></dd>
                                    </dl>

                                </div>
                            </div>


                            <div class="form-body moderation-block">
                                <strong class="form-sub-title">Moderation</strong>
                                <div class="form-group">
                                    <div class="moderation-actions" data-bind="visible: files().length && files().every(function(f){
                                        var s = ko.utils.unwrapObservable(f.idModerationStatus);
                                        return s != null && s !== 1;
                                        })">
                                        <button type="button" class="btn approved icon i-pencil-thin" data-bind="event: { click: function() { if (confirm('Are you sure you want to approve this mod?')) { onClickModerationAction('approve', 'mod', id) }}}"><span>Approve</span></button>
                                        <button type="button" class="btn rejected icon i-pencil-thin" data-bind="event: { click: function() { if (confirm('Are you sure you want to reject this mod?')) {onClickModerationAction('reject', 'mod', id) }}}"><span>Reject</span></button>
                                        <div class="content-modal rejection-modal" data-bind="attr: { 'id': 'modal-mod-reject-' + id }">
                                            <h3>Reason For Rejection:</h3><button type="button" class="btn close-button show-file-content" data-bind="event: { click: onClickSeeContent }" >X</button>
                                            <textarea class="reject-textarea" data-bind="attr: { 'id': 'mod-reject-' + id } "></textarea>
                                            <button type="button" class="btn" data-bind="event: { click: function() { onClickModerationAction('reject', 'mod', id) }}">
                                                <span>Save</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="moderation-actions" data-bind="visible: !(files().length && files().every(function(f){
                                        var s = ko.utils.unwrapObservable(f.idModerationStatus);
                                        return s != null && s !== 1;
                                        }))">
                                       Please moderate the files below in order to unlock mod approval.
                                    </div>
                                    <dl class="double-list margin">
                                        <dt class=""><span>MODERATION STATUS</span></dt>
                                        <dd class=""><span data-bind="text: (moderationStatus) ? moderationStatus : ''"></span></dd>
                                    </dl>
                                    <dl class="double-list margin" data-bind="visible: ko.unwrap(moderationStatus) === 'Rejected'
                                                                                    && (ko.unwrap(rejectionReason) || '').trim().length > 0"">
                                        <dt class=""><span>REASON FOR REJECTION:</span></dt>
                                        <dd class=""><span data-bind="text: (rejectionReason) ? rejectionReason : ''"></span></dd>
                                    </dl>
                                    <dl class="double-list margin">
                                        <dt class=""><span>LAST MODERATED BY</span></dt>
                                        <dd class=""><span data-bind="text: moderator"></span></dd>
                                    </dl>
                                    <dl class="double-list margin">
                                        <dt class=""><span>LAST MODERATED ON</span></dt>
                                        <dd class=""><span data-bind="text: dateModeration"></span></dd>
                                    </dl>
                                </div>
                            </div>

                        </div>

                        <div class="w-form-body">
                            <div class="form-body no-padding">
                                <strong class="form-sub-title">Primary Image</strong>
                                <div class="form-group">
                                    <dl class="double-list margin">
                                        <dt class="full-width"><span>Primary Image</span></dt>
                                        <dd class="full-width"><img data-bind="attr: { src: primaryImage }" style="width: 100%;"/></span></dd>
                                    </dl>
                                </div>

                                <strong class="form-sub-title">Description</strong>
                                <div class="form-group mod-description">
                                    <dl class="double-list margin">
                                        <dt class="full-width"><span>Description</span></dt>
                                        <dd class="full-width"><span data-bind="html: description"></span></dd>
                                    </dl>
                                </div>
                            </div>

                            <div class="form-body no-padding">

                                <strong class="form-sub-title">Other Images</strong>
                                <div class="form-group other-images">
                                    <dl class="double-list margin">
                                        <dt class="full-width"><span>Other Images</span></dt>
                                        <div data-bind="foreach: otherImages" style="grid-column-end: span 2;">
                                            <dd class="full-width"><img data-bind="attr: { src: url }" style="width: 100%;"/></dd>
                                        </div>
                                    </dl>
                                </div>

                                <strong class="form-sub-title">Version</strong>
                                <div class="form-group">
                                    <dl class="double-list margin">
                                        <dt class=""><span>Version</span></dt>
                                        <dd class=""><span data-bind="text: version"></span></dd>
                                    </dl>
                                </div>

                                <strong class="form-sub-title">Instructions</strong>
                                <div class="form-group">
                                    <dl class="double-list margin">
                                        <dt class="full-width"><span>Instructions</span></dt>
                                        <dd class="full-width no-cap"><span data-bind="html: instructions"></span></dd>
                                    </dl>
                                </div>

                                <strong class="form-sub-title">Dependencies</strong>
                                <div class="form-group mod-dependencies" data-bind="visible: internalDependencies().length > 0">
                                    <dl class="margin">
                                        <dt class="full-width"><span>Internal Dependencies</span></dt>
                                        <div data-bind="foreach: internalDependencies" style="grid-column-end: span 2;">
                                            <div class="dependency-block">
                                                <div><strong>Name:</strong> <span data-bind="text: name"></span></div>
                                                <div><strong>Mod ID:</strong> <span data-bind="text: idModReq"></span></div>
                                                <div><strong>Optional:</strong> <span data-bind="text: isOptional ? 'Yes' : 'No'"></span></div>
                                                <div data-bind="visible: notes"><strong>Notes:</strong> <span data-bind="text: notes"></span></div>
                                            </div>
                                        </div>
                                    </dl>
                                </div>
                                <div class="form-group mod-dependencies" data-bind="visible: externalDependencies().length > 0">
                                    <dl class="margin">
                                        <dt class="full-width"><span>External Dependencies</span></dt>
                                        <div data-bind="foreach: externalDependencies" style="grid-column-end: span 2;">
                                            <div class="dependency-block">
                                                <div><strong>Name:</strong> <span data-bind="text: name"></span></div>
                                                <div><strong>URL:</strong> <a data-bind="attr: { href: url }, text: url" target="_blank"></a></div>
                                                <div><strong>Optional:</strong> <span data-bind="text: isOptional ? 'Yes' : 'No'"></span></div>
                                                <div data-bind="visible: notes"><strong>Notes:</strong> <span data-bind="text: notes"></span></div>
                                            </div>
                                        </div>
                                    </dl>
                                </div>
                                <div class="form-group" data-bind="visible: internalDependencies().length === 0 && externalDependencies().length === 0">
                                    <dl class="margin">
                                        <dt class="full-width"><span>Mod Dependencies</span></dt>
                                        <dd class="full-width"><span>No dependencies</span></dd>
                                    </dl>
                                </div>

                                <strong class="form-sub-title">Files</strong>
                                <div class="form-group" style="margin-bottom:.5rem;"><h3 style="text-transform:uppercase">Files</h3></div>
                                <div class="form-group mod-files" data-bind="foreach: files" style="grid-column-end: span 2;">
                                    <div class="file-block"
                                        data-bind="css: {
                                            'moderation-waiting': !idModerationStatus || idModerationStatus === 1,
                                            'moderation-approved': idModerationStatus === 2,
                                            'moderation-rejected': idModerationStatus === 3
                                        }">
                                        <div class="w-form-2-column">
                                            <div class="block01">
                                                <!--<h4>File <span data-bind="text: $index() + 1"></span></h4>-->
                                                <div><strong>Name:</strong> <span data-bind="text: name"></span></div>
                                                <div><strong>Title:</strong> <span data-bind="text: title"></span></div>
                                                <div><strong>Description:</strong> <span data-bind="text: description"></span></div>
                                                <div><strong>Version:</strong> <span data-bind="text: version"></span></div>
                                                <div><strong>Status:</strong> <span data-bind="text: moderationStatus ? moderationStatus.name : ''"></span></div>
                                                <div><strong>Deleted:</strong> <span data-bind="text: isDeleted ? 'Yes' : 'No'"></span></div>
                                                <div data-bind="visible: moderationStatus && (moderationStatus.name == 'Rejected' && rejectionReason != null)" ><strong>Reason For Rejection:</strong> <span data-bind="text: rejectionReason "></span></div>
                                                <div><strong>Content:</strong> <button type="button" class="btn show-file-content" data-bind="event: { click: function(data, e){ $parent.onClickSeeContent(($index() + 1), e) } }" >see content</button><div class="content-modal" data-bind="attr: { 'id': 'file-item-' + ($index() + 1) }"><button type="button" class="btn close-button show-file-content" data-bind="event: { click: $parent.onClickSeeContent }" >X</button><span data-bind="html: content "></div></span></div>
                                            </div>
                                            <div class="block02">
                                                <h2 data-bind="css: {
                                                    'moderation-waiting': !idModerationStatus || idModerationStatus === 1,
                                                    'moderation-approved': idModerationStatus === 2,
                                                    'moderation-rejected': idModerationStatus === 3
                                                }"><span data-bind="text: (!moderationStatus) ? 'Awaiting Moderation' : 'Moderation '+moderationStatus.name"></span></h2>
                                                <div class="moderation-actions">

                                                    <!-- button type="button" class="btn approved icon i-pencil-thin" data-bind="visible: !idModerationStatus || idModerationStatus !== 2, event: { click: function() { if (confirm('Are you sure you want to approve this file?')) { $parent.onClickModerationAction('approve', 'file', id) }}}"><span class="step-check icon i-check"></span></button -->
                                                    <!-- button type="button" class="btn rejected icon i-pencil-thin" data-bind="visible: !idModerationStatus || idModerationStatus !== 3, event: { click: function() { if (confirm('Are you sure you want to reject this file?')) { $parent.onClickModerationAction('reject', 'file', id) }}}"><span class="step-check icon i-cancel"></span></button -->

                                                    <button type="button" class="btn approved icon i-pencil-thin" data-bind=" event: { click: function() { if (confirm('Are you sure you want to approve this file?')) { $parent.onClickModerationAction('approve', 'file', id) }}}"><span class="step-check icon i-check"></span></button>
                                                    <button type="button" class="btn rejected icon i-pencil-thin" data-bind=" event: { click: function() { if (confirm('Are you sure you want to reject this file?')) { $parent.onClickModerationAction('reject', 'file', id) }}}"><span class="step-check icon i-cancel"></span></button>
                                                    <div class="content-modal rejection-modal" data-bind="attr: { 'id': 'modal-file-reject-' + id }">
                                                        <h3>Reason For Rejection:</h3><button type="button" class="btn close-button show-file-content" data-bind="event: { click: $parent.onClickSeeContent }" >X</button>
                                                        <textarea class="reject-textarea" data-bind="attr: { 'id': 'file-reject-' + id } "></textarea>
                                                        <button type="button" class="btn" data-bind="event: { click: function() { $parent.onClickModerationAction('reject', 'file', id) }}">
                                                            <span>Save</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="file-download">
                                                    <button type="button" class="btn icon i-pencil-thin" data-bind="event: { click: function() { event.preventDefault(); $parent.onClickDownload(url) }}"><span>Download</span></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                    </div>
                        <div class="generic-modal"><!-- button type="button" class="btn show-file-content" data-bind="event: { click: onClickSeeContent }" >X</button -->
                        </div>
                    </div>


            </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string{
        return "modView-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            id: ko.observable("")
            ,title: ko.observable("")
            ,shortDescription: ko.observable("")
            ,modder: ko.observable()
            ,modderId: ko.observable()
            ,status: ko.observable("")
            ,idOrigin: ko.observable("")
            ,isModProbation: ko.observable(false)
            ,tag: ko.observable("")
            ,isAdultOnly: ko.observable("")
            ,ggpOptIn: ko.observable("")
            ,modTypes: ko.observableArray([])
            ,idModerationStatus: ko.observable()
            ,moderationStatus: ko.observableArray([])
            ,idModerator: ko.observable()
            ,moderator: ko.observable("")
            ,dateModeration: ko.observable("")
            ,primaryImage: ko.observable("")
            ,otherImages: ko.observableArray([])
            ,files: ko.observableArray([])
            ,version: ko.observable("")
            ,instructions: ko.observable("")
            ,description: ko.observable("")
            ,created: ko.observable("")
            ,updated: ko.observable("")
            ,lockItem: ko.observable(true)
            ,rejectionReason: ko.observable("")
            ,valnetUser: ko.observable()
            ,modDependencies: ko.observableArray([])
            ,internalDependencies: ko.observableArray([])
            ,externalDependencies: ko.observableArray([])
            ,onClickCancel: function (data, event) { huit_neuf_this.onClickCancel(data) }
            ,onClickEdit: function (data, event) { huit_neuf_this.onClickEdit(data) }
            ,onClickSeeContent: function (data, event) { huit_neuf_this.onClickSeeContent(data, event) }
            ,onClickModerationAction: function (action, objType, id, data, event) { huit_neuf_this.onClickModerationAction(action, objType, id, data, event) }
            ,onClickDownload: function (fileUrl, data, event) { huit_neuf_this.onClickDownload(fileUrl ) }
        };
    }

    public getViewModelForRequest() {

        return {
            lockItem : this.getTemplateViewModel().lockItem
        }
    }

    public onClickEdit(data){
        this.caller.edit(data.id());
    }

    public onClickCancel(data){
        this.caller.cancel(data.id());
    }

    public onClickSeeContent(data, event){
        console.log('Event', event);
        this.caller.seeContent(data, event);
    }

    public onClickModerationAction(action, objType, id, data, event){

        let rejectionReasonElem = document.getElementById(objType +'-reject-' + id) as HTMLTextAreaElement;

        if(action === 'reject' && rejectionReasonElem.value.trim() === '') {
            //event.preventDefault();
            let modal = document.getElementsByClassName('generic-modal');
            let content = document.getElementById('modal-' + objType + '-reject-' + id);
            if(modal.length > 0) {
                modal[0].classList.contains('is-showing') ? modal[0].classList.remove('is-showing') : modal[0].classList.add('is-showing');
            }
            if(content != null && content != undefined) {
                content.classList.contains('is-showing') ? content.classList.remove('is-showing') : content.classList.add('is-showing');
            }else{
                let contentModal = document.getElementsByClassName('content-modal');
                for (let i = 0; i < contentModal.length; i++) {
                    contentModal[i].classList.remove('is-showing');
                }

            }

        }else{
            let rejectReason = '';
            if(action == 'reject') {
                rejectReason = rejectionReasonElem.value;
            }

            this.caller.moderationAction(action, objType, id, rejectReason);
        }
    }
    public onClickDownload(fileUrl){
        this.caller.downloadFile(fileUrl);
    }

    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public setTitle(title){
        this.getTemplateViewModel().title(title);
    }

    public setShortDescription(shortDescription){
        this.getTemplateViewModel().shortDescription(
            shortDescription != null && shortDescription !== undefined ? String(shortDescription) : ""
        );
    }

    public setModder(modder){
        this.getTemplateViewModel().modder(modder);
    }

    public setModderId(modderId){
        this.getTemplateViewModel().modderId(modderId);
    }

    public setStatus(status){
        this.getTemplateViewModel().status(status);
    }

    public setIdOrigin(idOrigin){
        this.getTemplateViewModel().idOrigin(idOrigin);
    }

    public setIsModProbation(isModProbation){
        this.getTemplateViewModel().isModProbation(isModProbation);
    }

    public setValnetUser(valnetUser){
        this.getTemplateViewModel().valnetUser(valnetUser);
    }

    public setTag(tag){
        this.getTemplateViewModel().tag(tag);
    }

    public setIsAdultOnly(isAdultOnly){
        const yes = isAdultOnly === 1 || isAdultOnly === true || isAdultOnly === '1';
        this.getTemplateViewModel().isAdultOnly(yes ? 'Yes' : 'No');
    }

    public setGgpOptIn(ggpOptIn){
        const yes = ggpOptIn === 1 || ggpOptIn === true || ggpOptIn === '1';
        this.getTemplateViewModel().ggpOptIn(yes ? 'Yes' : 'No');
    }

    public setModTypes(modTypes){
        this.getTemplateViewModel().modTypes(modTypes);
    }

    public setIdModerationStatus(idModerationStatus){
        this.getTemplateViewModel().idModerationStatus(idModerationStatus);
    }

    public setModerationStatus(moderationStatus){
        this.getTemplateViewModel().moderationStatus(moderationStatus);
    }

    public setIdModerator(idModerator){
        this.getTemplateViewModel().idModerator(idModerator);
    }

    public setModerator(moderator){
        this.getTemplateViewModel().moderator(moderator);
    }

    public setDateModeration(dateModeration){
        this.getTemplateViewModel().dateModeration(dateModeration);
    }

    public setPrimaryImage(primaryImage){
        this.getTemplateViewModel().primaryImage(primaryImage);
    }

    public setOtherImages(otherImages){
        this.getTemplateViewModel().otherImages(otherImages);
    }

    public setFiles(files){
        this.getTemplateViewModel().files(files);
    }

    public setFileTree(fileTree){
        this.getTemplateViewModel().fileTree(fileTree);
    }

    public setVersion(version){
        this.getTemplateViewModel().version(version);
    }

    public setInstructions(instructions){
        this.getTemplateViewModel().instructions(instructions);
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description);
    }

    public setCreated(created){
        this.getTemplateViewModel().created(created);
    }

    public setUpdated(updated){
        this.getTemplateViewModel().updated(updated);
    }

    public setRejectionReason(rejectionReason){
        this.getTemplateViewModel().rejectionReason(rejectionReason);
    }

    public setModDependencies(modDependencies){
        this.getTemplateViewModel().modDependencies(modDependencies);

        // Internal dependencies have idModReq defined
        const internal = modDependencies.filter(dep => dep.idModReq);
        this.getTemplateViewModel().internalDependencies(internal);

        // External dependencies have url defined
        const external = modDependencies.filter(dep => dep.url);
        this.getTemplateViewModel().externalDependencies(external);
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/modView_template.ts